export default {
    title: 'MEMBRE',
    section1: {
        heading: 'CONSEILS SUR MESURE',
        description: 'Les Membres ont accès à un service personnalisé et des conseils d\'experts.'
    },
    section2: {
        heading: 'ACCÈS PRIVILÈGE À DES VINS',
        description: 'Les Membres ont accès aux allocations et à certains produits qui ne se retrouvent pas sur nos listes.'
    },
    section3: {
        heading: 'PRIX PRÉFÉRENTIELS',
        description: 'Les Membres ont accès à des prix préférentiels sur les bouteilles vendues à l\'unité.'
    },
    section4: {
        heading: 'DÉGUSTATIONS SUR RENDEZ-VOUS',
        description: 'Les Membres ont droit jusqu\'à 4 dégustations en magasin par année accompagnés d\'une personne non membre de leur choix'
    },
    section5: {
        heading: 'ÉVÉNEMENTS PRIVÉS',
        list: [
            ' 5@7 avec des vignerons',
            'Dégustations nouveaux arrivages',
            'Événements exclusifs'
        ]
    },
    andMuchMore: 'Et bien plus encore !',
    becomeMember: 'DEVENEZ MEMBRE',
    plan: '150',
    subscribe: 'S’abonner',
    year: '/an'
};
